module.exports = __webpack_public_path__ + "static/media/Nuevo Cliente.89f6a1e2.svg";